export const SideMenu = {
    Items: {
        Home: {
            title: 'Home'
        },
        CompletedJobs: {
            title: 'Job History'
        },
        Preferences: {
            title: 'Preferences'
        },
        ContactGoTrashy: {
            title: 'Contact curb-it'
        },
        Tutorial: {
            title: 'Tutorial'
        },
        Help:{
            title: 'Help'
        },
        LogOut: {
            title: 'Log Out'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/SideMenu.ts